import { getOrderPassengerPoints } from "../../../../../../../redux/constants/OrdersPage/order";

import type { Order } from "../../../../../../../services";

const cellProcessing = (item: Order.Model, language: string) => {
	const points = getOrderPassengerPoints(item);
	return points[0]?.sector?.name?.[language] ?? "";
};

export default cellProcessing;
